import React, { memo } from 'react';
import { Box, BoxProps, Center, Spinner, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from '@chakra-ui/react';
import BarChart, { BarChartVariant } from '../../../components/BarChart';
import { useTransactionBarChartData } from '../hook/useTransactionBarChartData';

interface TransactionBarChartProps extends BoxProps {
  idMerchant?: string[];
  idBranch?: string[];
}

interface TabOption {
  label: string;
  showAxisBottom: boolean;
  variant: BarChartVariant;
}

const tabOptions: TabOption[] = [
  {label: "Dia", showAxisBottom: false, variant: 'bars'},
  {label: "Semana", showAxisBottom: true, variant: 'bars'},
  {label: "Mes", showAxisBottom: true, variant: 'points-line'},
  {label: "Año", showAxisBottom: true, variant: 'bars'}
]

const TransactionBarChart = ({ idMerchant, idBranch, ...boxProps }: TransactionBarChartProps) => {

  const { selectedTab, setSelectedTab, results, loading, error } = useTransactionBarChartData({ idMerchant, idBranch });

  return (
    <Box p={1} borderWidth="1px" borderRadius="lg" overflow="hidden" pt="xl" h="100%" {...boxProps}>
      <Text fontSize="xl" mb={4} fontWeight="bold"  pl="l">Transacciones Totales</Text>
      <Tabs index={selectedTab} onChange={setSelectedTab} colorScheme="button-primary">
        <TabList>
          {
            tabOptions.map((option, index) => (
              <Tab key={`tab-${index}`}>{option.label}</Tab>
            ))
          }
        </TabList>
        <TabPanels >
          {
            tabOptions.map(( item, index) => (
              <TabPanel key={`tab-panel-${index}`} pl="0">
                {loading && <Center paddingY="xxl" color="neutral.600"><Spinner /></Center>}
                {!loading && !!error && <Center paddingY="xxl" color="destructive.700">{error}</Center>}
                {!loading && !error && <BarChart data={results} showAxisBottomLegend={item.showAxisBottom} variant={item.variant}/>}
              </TabPanel>
            ))
          }
        </TabPanels>
      </Tabs>
    </Box>
  )
}

export default memo(TransactionBarChart)
